<script>

    import { toast } from 'bulma-toast'

    import StpService from '../$services/stp.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'
    import Spinner from '../$components/spinner.svelte'

    let saldo = null
    let loading = false

    getSaldo()

    async function getSaldo() {

        loading = true
        const resp = await StpService.getSaldo()
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        saldo = resp.data
    }

</script>

<Spinner {loading} />

{#if !loading && saldo}
    <InfoCard subtitle="Saldo STP">
        <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
            <InfoField label="Saldo" icon="fas fa-wallet" value={ NumeralMethods.cash(saldo.saldo) } bold color="success" />
            <InfoField label="Cargos" icon="fas fa-arrow-up" value={ NumeralMethods.cash(saldo.cargos) } />
        </div>
    </InfoCard>
{/if}